import { useEffect, useState } from 'react';
import { MessageCircle, MessagesSquare, Megaphone } from 'lucide-react';
import ConversationsPanel from '../components/ConversationsPanel';
import BroadcastPanel from '../components/BroadcastPanel';
import { getMessagesUnread } from '../api';

type Tab = 'chat' | 'difusion';

export default function MessagesPage() {
  const [tab, setTab] = useState<Tab>('chat');
  const [unread, setUnread] = useState(0);

  useEffect(() => { getMessagesUnread().then((r) => setUnread(r.unread)).catch(() => {}); }, [tab]);

  const tabs: { key: Tab; label: string; icon: typeof MessagesSquare; badge?: number }[] = [
    { key: 'chat', label: 'Conversaciones', icon: MessagesSquare, badge: unread },
    { key: 'difusion', label: 'Difusión', icon: Megaphone },
  ];

  return (
    <div className="mx-auto max-w-6xl">
      <div className="mb-4">
        <h1 className="flex items-center gap-2 font-display text-2xl font-bold text-content">
          <MessageCircle className="text-brand-blue" size={24} /> Mensajes
        </h1>
        <p className="mt-0.5 text-sm text-content-3">Conversa 1-a-1 con un alumno o manda un aviso por WhatsApp a un grupo.</p>
      </div>

      {/* Pestañas */}
      <div className="mb-5 inline-flex rounded-lg border border-line bg-surface p-1">
        {tabs.map(({ key, label, icon: Icon, badge }) => (
          <button key={key} onClick={() => setTab(key)}
            className={`inline-flex items-center gap-2 rounded-md px-4 py-1.5 text-sm font-medium transition ${
              tab === key ? 'bg-accent text-on-accent shadow-sm' : 'text-content-2 hover:text-content'}`}>
            <Icon size={16} /> {label}
            {!!badge && badge > 0 && (
              <span className={`grid h-5 min-w-5 place-items-center rounded-full px-1 text-[10px] font-bold ${
                tab === key ? 'bg-on-accent/20 text-on-accent' : 'bg-accent text-on-accent'}`}>{badge}</span>
            )}
          </button>
        ))}
      </div>

      {tab === 'chat' ? <ConversationsPanel /> : <BroadcastPanel />}
    </div>
  );
}
